import { render, staticRenderFns } from "./checkNegative.vue?vue&type=template&id=20526f9c&scoped=true"
import script from "./checkNegative.vue?vue&type=script&lang=js"
export * from "./checkNegative.vue?vue&type=script&lang=js"
import style0 from "./checkNegative.vue?vue&type=style&index=0&id=20526f9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20526f9c",
  null
  
)

export default component.exports